// client/baseqlClient.ts
import { BehaviorSubject, firstValueFrom } from "rxjs";
import { filter } from "rxjs/operators";
import "../requestHandler";
import { SubscriptionDedupe } from "./requestHandlers/subscriptionDedupe";
import { SynchronousDedupe } from "./requestHandlers/synchronousDedupe";
import { UnpackHandler } from "./requestHandlers/unpack";
import { UpgradeHandler } from "./requestHandlers/upgrade";
import { BaseQLWebsocketTransport } from "./transports/websocketTransport";
var TransportWrapper = class {
  constructor(constructUpstream) {
    this.constructUpstream = constructUpstream;
    this.destroyed = false;
    this.available = true;
  }
  get upstream() {
    if (this._upstream?.available)
      return this._upstream;
    return this._upstream = typeof this.constructUpstream === "function" ? this.constructUpstream() : this.constructUpstream;
  }
  subscription(op, payload) {
    return this.upstream.subscription(op, payload);
  }
  query(op, payload) {
    return this.upstream.query(op, payload);
  }
  mutation(op, payload) {
    return this.upstream.mutation(op, payload);
  }
  destroy() {
    if (this.destroyed)
      throw new Error("Destroying an already destroyed TransportWrapper");
    this.destroyed = true;
    return this.upstream.destroy();
  }
  stop(payload) {
    return this.upstream.stop(payload);
  }
  startSession(payload) {
    this.upstream.startSession(payload);
  }
  closeSession() {
    this.upstream.closeSession();
  }
};
var BaseQLClient = class {
  static initDefault() {
    const transportHandler = this.createTransportHandler();
    this.initHandler(transportHandler);
  }
  static createTransportHandler(transportFactory) {
    transportFactory ?? (transportFactory = () => {
      return BaseQLWebsocketTransport.get({ sessionID: localStorage.getItem("sessionID") ?? "" });
    });
    const transport = new TransportWrapper(transportFactory);
    const transportHandler = new UpgradeHandler(new UnpackHandler(transport));
    this.setTransport(transport);
    return transportHandler;
  }
  static getTransport() {
    return firstValueFrom(this.transport.pipe(filter(Boolean)));
  }
  static setTransport(handler) {
    this.transport.next(handler);
    this.hasTransport = true;
  }
  static getRequestHandler() {
    return firstValueFrom(this.requestHandler.pipe(filter(Boolean)));
  }
  static initHandler(handler) {
    if (!this.hasTransport)
      throw new Error(
        "No transport defined yet. Please construct a transportHandler with createTransportHandler and incorporate it into your requestHandler before calling this."
      );
    this.requestHandler.next(new SynchronousDedupe(new SubscriptionDedupe(handler)));
  }
};
BaseQLClient.sessionID = "";
BaseQLClient.connectionID = "";
BaseQLClient.hasTransport = false;
BaseQLClient.transport = new BehaviorSubject(null);
BaseQLClient.requestHandler = new BehaviorSubject(null);
export {
  BaseQLClient
};
